import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/riyadh-season/register.ts
import { Exception } from "@wbk/logger";
var registerCompetition = (formData) => __async(void 0, null, function* () {
  var _a;
  try {
    const captcha = yield generateRecaptchaToken("register_competition");
    formData.append("captcha", captcha);
    const data = yield fetchClient({
      url: "/riyadh_season/submission",
      formData: true,
      options: {
        method: "POST",
        body: formData
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || (data == null ? void 0 : data.error);
      throw new Error(String(msg));
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "registerCompetitionException"
    });
  }
});

export {
  registerCompetition
};
//# sourceMappingURL=chunk-VUFEVYR6.mjs.map